'use client'

import React, { type KeyboardEvent } from 'react'
import { AnimatedCounter } from 'react-animated-counter'

import { cn } from '@src/utils/tailwind'

interface NumberCountdownProps {
  textStyle: string
  animated: boolean
  selectedTimePeriod: number
  builderBlock: any
  animatedBackground: string
  onClick?: () => Promise<void>
  onKeyDown?: (e: KeyboardEvent) => Promise<void>
  role?: string
  tabIndex?: number
}

export default function NumberCountdown(props: NumberCountdownProps) {
  const {
    textStyle,
    animated,
    selectedTimePeriod,
    builderBlock,
    animatedBackground,
    role,
    tabIndex,
    onClick,
    onKeyDown,
  } = props

  const clickActionProps = {
    role,
    tabIndex,
    onClick,
    onKeyDown,
  }

  // currently just getting the large styles which are the default ones on builder
  const currentStyles = builderBlock?.responsiveStyles?.large
  return (
    <>
      {animated ? (
        <div
          {...clickActionProps}
          className={cn('builder-text prose flex flex-row gap-1', textStyle)}
        >
          <div className="rounded-sm p-1" style={{ backgroundColor: animatedBackground }}>
            <AnimatedCounter
              value={Math.floor((selectedTimePeriod / 10) % 10)}
              decimalPrecision={0}
              fontSize={currentStyles?.fontSize}
              color={currentStyles?.color}
              incrementColor={currentStyles?.color}
              decrementColor={currentStyles?.color}
            />
          </div>
          <div className="rounded-sm p-1" style={{ backgroundColor: animatedBackground }}>
            <AnimatedCounter
              value={selectedTimePeriod % 10}
              decimalPrecision={0}
              fontSize={currentStyles?.fontSize}
              color={currentStyles?.color}
              incrementColor={currentStyles?.color}
              decrementColor={currentStyles?.color}
            />
          </div>
        </div>
      ) : (
        <span
          {...clickActionProps}
          className={cn('builder-text prose', textStyle)}
          suppressHydrationWarning
        >
          {String(selectedTimePeriod).padStart(2, '0')}
        </span>
      )}
    </>
  )
}
